<template>
  <div class="parent">
    <b-row>
      <b-col>
        <!-- Breadcrumb Component -->
        <!-- <vs-breadcrumb class="bc mb-5">
          <vs-icon
            icon="content_paste"
            size="small"
            class="vsicon mr-2"
          ></vs-icon>
          <li>
            <a> Report Center </a>
            <span class="vs-breadcrum--separator"> > </span>
          </li>
          <li>
            <a> Journey Report </a>
            <span class="vs-breadcrum--separator"> > </span>
          </li>
          <li aria-current="page" class="active">Map Journey</li>
        </vs-breadcrumb> -->

        <!-- Date Input Component -->
        <div class="date-input">
          <b-card class="date-input-card mb-5">
            <b-form>
              <b-row class="d-flex justify-content-center align-items-center">
                <!-- <b-col cols="3">
                  <b-form-group label="Pilih Unit" label-for="v-unit">
                    <v-select
                      v-model="selected"
                      label="title"
                      :options="units"
                    />
                  </b-form-group>
                </b-col> -->
                <b-col>
                  <b-form-group label="Start Time" label-for="v-tgl-mulai">
                    <!-- <flat-pickr
                      placeholder="Tanggal Mulai"
                      class="date-picker form-control"
                    /> -->
                    <div class="start-time d-flex align-items-center p-2">
                      {{ formatDate(data.start) }}
                    </div>
                    <!-- <b-form-datepicker id="example-datepicker" /> -->
                    <!-- <v-select label="title" /> -->
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="End Time" label-for="v-tgl-selesai">
                    <!-- <flat-pickr
                      placeholder="Tanggal Selesai"
                      class="date-picker form-control"
                    /> -->
                    <div class="end-time d-flex align-items-center p-2">
                      {{ formatDate(data.end) }}
                    </div>
                    <!-- <v-select label="title" /> -->
                  </b-form-group>
                </b-col>
                <!-- <b-col class="align-self-center">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    id="btn-cari"
                    block
                  >
                    Cari
                  </b-button>
                </b-col> -->
              </b-row>
            </b-form>
          </b-card>
        </div>

        <!-- Leaflet Map Component -->
        <l-map
          class="map"
          ref="peta"
          :zoom="zoom"
          :options="{ zoomControl: false }"
          :center="latLngx(data.lat, data.lon)"
          @zoomend="handleZoomEnd"
        >
          <!-- @update:center="centerUpdate" -->
          <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            layer-type="base"
            :options="{ maxZoom: 22 }"
          />

          <l-polyline
            :lat-lngs="polyline.latlngs"
            :color="polyline.color"
            :weight="polyline.weight"
          ></l-polyline>

          <template v-if="data.vehicle_status !== 'Parking'">
            <!-- Moving Sign -->
            <l-marker
              v-for="(item, index) in dataMarkerMoving"
              :key="'moving' + index"
              :lat-lng="latLngx(item.lat, item.lon)"
              :icon="markerMoving.icon"
              :visible="movingSwitch"
              @click="showAddress(item.lat, item.lon)"
            >
              <l-popup>
                <template class="popup-data">
                  <div
                    class="header-popup p-3 d-flex justify-content-between"
                    style="
                      background: #1da1f2;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                      font-family: 'Poppins', sans-serif;
                    "
                  >
                    <span>Moving</span>
                    <div
                      class="mr-lg-3 d-flex align-items-center gap-1"
                      style="font-weight: 400; font-size: 13px"
                    >
                      <img
                        class="d-flex align-items-center"
                        src="@/assets/images/tabler-icon/edited/speed-white.svg"
                      />
                      <span> {{ item.speed }} km/h </span>
                    </div>
                  </div>
                  <div
                    class="content-popup p-3"
                    style="font-family: 'Poppins', sans-serif"
                  >
                    <p>{{ address }}</p>
                  </div>
                </template>
              </l-popup>
            </l-marker>

            <!-- Alert Sign -->
            <l-marker
              v-for="(item, index) in dataMarkerAlert"
              :key="'alert' + index"
              :lat-lng="latLngx(item.lat, item.lon)"
              :icon="markerAlert.icon"
              :visible="alertSwitch"
              @click="showAddress(item.lat, item.lon)"
            >
              <l-popup>
                <template class="popup-data">
                  <div
                    class="header-popup p-3 d-flex justify-content-between"
                    style="
                      background: #db4437;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                    "
                  >
                    <!-- <span class="d-flex align-items-center">Alarm</span> -->
                    <div
                      class="mr-lg-3 d-flex align-items-center gap-1"
                      style="
                        font-weight: 400;
                        font-size: 13px;
                        font-family: 'Poppins', sans-serif;
                      "
                    >
                      <img
                        class="d-flex align-items-center"
                        src="@/assets/images/tabler-icon/edited/bell-ringing-white.svg"
                      />
                      <span> {{ item.alarm }} </span>
                    </div>
                  </div>
                  <div
                    class="content-popup p-3"
                    style="font-family: 'Poppins', sans-serif"
                  >
                    <p>{{ address }}</p>
                  </div>
                </template>
              </l-popup>
            </l-marker>

            <!-- Stop Sign -->
            <l-marker
              v-for="(item, index) in dataMarkerStop"
              :key="'stop' + index"
              :lat-lng="latLngx(item.lat, item.lon)"
              :icon="markerStop.icon"
              :visible="stopSwitch"
              @click="showAddress(item.lat, item.lon)"
            >
              <l-popup>
                <div
                  class="popup-data"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <div
                    class="header-popup p-3 d-flex justify-content-between"
                    style="
                      background: #4b465c;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                    "
                  >
                    <span>Stop</span>
                    <!-- <div
                      class="mr-lg-3 d-flex align-items-center gap-1"
                      style="font-weight: 400; font-size: 13px"
                    >
                      <img
                        class="d-flex align-self-center"
                        src="@/assets/images/tabler-icon/edited/clock-white.svg"
                      />
                      <span>
                        {{ convertSecToMin(data.duration) }}
                      </span>
                    </div> -->
                  </div>
                  <div class="content-popup p-3">
                    <p>
                      {{ address }}
                    </p>
                  </div>
                </div>
              </l-popup>
            </l-marker>

            <!-- Start Sign -->
            <l-marker
              :lat-lng="latLngx(dataDetail[0].lat, dataDetail[0].lon)"
              :icon="markerStart.icon"
            >
              <l-popup>
                <div class="popup-data">
                  <div
                    class="header-popup p-3"
                    style="
                      background: green;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                      font-family: 'Poppins', sans-serif;
                    "
                  >
                    Start
                  </div>
                  <div
                    class="content-popup p-3"
                    style="font-family: 'Poppins', sans-serif"
                  >
                    <p>
                      {{ data.start_address }}
                    </p>
                  </div>
                </div>
              </l-popup>
            </l-marker>

            <!-- Finish Sign -->
            <l-marker
              :lat-lng="
                latLngx(
                  dataDetail[dataDetail.length - 1].lat,
                  dataDetail[dataDetail.length - 1].lon
                )
              "
              :icon="markerFinish.icon"
            >
              <l-popup>
                <div class="popup-data">
                  <div
                    class="header-popup p-3"
                    style="
                      background: #ea5455;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                      font-family: 'Poppins', sans-serif;
                    "
                  >
                    Finish
                  </div>
                  <div
                    class="content-popup p-3"
                    style="font-family: 'Poppins', sans-serif"
                  >
                    <p>
                      {{ data.end_address }}
                    </p>
                  </div>
                </div>
              </l-popup>
            </l-marker>

            <l-rotated-marker
              v-if="showElement"
              :lat-lng="latLngx(dataDetail[0].lat, dataDetail[0].lon)"
              :icon="markerVehicle"
              :rotationAngle="angleVehicle"
            >
            </l-rotated-marker>

            <l-rotated-marker
              :lat-lng="centerUpdate"
              ref="vehicle"
              :icon="markerx"
              :rotationAngle="angleVehicle"
            >
            </l-rotated-marker>
          </template>

          <template v-if="data.vehicle_status === 'Parking'">
            <!-- Parking Sign -->
            <l-marker
              :lat-lng="latLngx(data.lat, data.lon)"
              :icon="markerParking"
            >
              <l-popup>
                <div
                  class="popup-data"
                  style="font-family: 'Poppins', sans-serif"
                >
                  <div
                    class="header-popup p-3 d-flex justify-content-between"
                    style="
                      background: #4b465c;
                      color: #fff;
                      font-weight: 600;
                      font-size: 15px;
                    "
                  >
                    <span>Parking</span>
                    <div
                      class="mr-lg-3 d-flex align-items-center gap-1"
                      style="font-weight: 400; font-size: 13px"
                    >
                      <img
                        class="d-flex align-self-center"
                        src="@/assets/images/tabler-icon/edited/clock-white.svg"
                      />
                      <span> {{ convertSecToMin(data.duration) }} </span>
                    </div>
                  </div>
                  <div class="content-popup p-3">
                    <p>
                      {{ data.address }}
                    </p>
                  </div>
                </div>
              </l-popup>
            </l-marker>
          </template>

          <!-- Timeline Top Left -->
          <l-control position="topleft">
            <b-card class="timeline-card">
              <div class="timeline text-left">
                <div class="timeline-wrapper">
                  <ul
                    class="timeline-sessions"
                    style="font-family: 'Poppins', sans-serif"
                  >
                    <li class="session-1">
                      <p class="session-content">
                        <template v-if="data.vehicle_status !== 'Parking'">
                          <div class="session-title text-muted">
                            Start Location
                          </div>
                          <template v-if="data.start_address.length > 80">
                            {{ data.start_address.substring(0, 50) }}...
                            <a class="d-block" v-b-modal.lokasi-awal-popup>
                              <em>See Detail</em>
                            </a>
                          </template>
                          <template v-else>
                            {{ data.start_address }}
                          </template>
                          <p class="text-muted session-date">
                            {{ data.start }}
                          </p>
                        </template>
                        <template v-else>
                          <div class="session-title text-muted">
                            Start Parking
                          </div>
                          <p class="text-muted session-date date-parking">
                            {{ data.start }}
                          </p>
                        </template>
                      </p>
                    </li>
                    <li class="session-2">
                      <p class="session-content">
                        <template v-if="data.vehicle_status !== 'Parking'">
                          <div class="session-title text-muted">
                            Finish Location
                          </div>
                          <template v-if="data.end_address.length > 80">
                            {{ data.end_address.substring(0, 50) }}...
                            <a class="d-block" v-b-modal.lokasi-akhir-popup>
                              <em>See Detail</em>
                            </a>
                          </template>
                          <template v-else>
                            {{ data.end_address }}
                          </template>
                          <p class="text-muted session-date">{{ data.end }}</p>
                        </template>
                        <template v-else>
                          <div class="session-title text-muted">
                            End Parking
                          </div>
                          <p class="text-muted session-date date-parking">
                            {{ data.end }}
                          </p>
                        </template>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </b-card>
          </l-control>

          <!-- Status Switch Top Right -->
          <l-control position="topright" class="d-flex">
            <div
              class="switch p-3"
              style="font-family: 'Poppins', sans-serif"
              :class="data.vehicle_status !== 'Parking' ? '' : 'd-none'"
            >
              <vs-switch
                v-model="movingSwitch"
                color="#1da1f2"
                class="switch-button"
                name="switch-button"
              />
              <span>Moving Point</span>
            </div>

            <div
              class="switch p-3"
              style="font-family: 'Poppins', sans-serif"
              :class="data.vehicle_status !== 'Parking' ? '' : 'd-none'"
            >
              <vs-switch
                v-model="stopSwitch"
                color="#4B465C"
                class="switch-button"
                name="switch-button"
              />
              <span>Stop Point</span>
            </div>

            <div
              class="switch p-3"
              style="font-family: 'Poppins', sans-serif"
              :class="data.vehicle_status !== 'Parking' ? '' : 'd-none'"
            >
              <vs-switch
                v-model="alertSwitch"
                color="danger"
                class="switch-button"
                name="switch-button"
              />
              <span>Alarm Point</span>
            </div>
          </l-control>

          <!-- Controls Bottom Left -->
          <l-control position="bottomleft">
            <div class="control p-3">
              <vs-icon icon="speed" size="small"></vs-icon>
            </div>
            <div class="control p-3">
              <vs-icon icon="maps" size="small"></vs-icon>
            </div>
            <div class="control p-3">
              <vs-icon icon="wifi" size="small"></vs-icon>
            </div>
          </l-control>

          <l-control-zoom
            position="bottomright"
            class="zoom-control"
          ></l-control-zoom>
          <l-control-fullscreen
            position="bottomright"
            :options="{
              title: { false: 'Fullscreen', true: 'RegularScreen' }
            }"
          />
          <l-control-layers position="bottomright"></l-control-layers>
        </l-map>
      </b-col>

      <!-- Modal Lokasi Awal Detail -->
      <b-modal
        id="lokasi-awal-popup"
        modal-class="lokasi-awal-popup"
        header-class="lokasi-awal-header"
        header-text-variant="light"
        title="Start Location"
        hide-footer
        hide-header-close
        centered
      >
        <b-button
          class="close-modal-btn"
          @click="$bvModal.hide('lokasi-awal-popup')"
        >
          X
        </b-button>
        <div class="lokasi-awal-detail px-2">
          {{ data.start_address }}
        </div>
      </b-modal>

      <!-- Modal Lokasi Akhir Detail -->
      <b-modal
        id="lokasi-akhir-popup"
        modal-class="lokasi-akhir-popup"
        header-class="lokasi-akhir-header"
        header-text-variant="light"
        title="Finish Location"
        centered
        hide-footer
        hide-header-close
      >
        <b-button
          class="close-modal-btn"
          @click="$bvModal.hide('lokasi-akhir-popup')"
        >
          X
        </b-button>
        <div class="lokasi-akhir-detail px-2">
          {{ data.end_address }}
        </div>
      </b-modal>
      <!-- List Status Component -->
      <b-col
        cols="3"
        :class="data.vehicle_status !== 'Parking' ? '' : 'd-none'"
      >
        <b-card no-body class="list-card">
          <b-card class="list-item-title">
            <h5>Trip Details</h5>
          </b-card>
          <div class="list-container">
            <ul v-for="(item, index) in dataDetail" :key="'list' + index">
              <li @click="centerMap(item, data.fullpath_icon)">
                <div class="list-item p-5" style="cursor: pointer">
                  <div
                    class="list-item-heading d-flex d-inline justify-content-between"
                  >
                    <b-form-radio name="rincian-perjalanan" class="radio-btn">
                      <h5>{{ item.time }}</h5>
                      <p>{{ item.date_time }}</p>
                    </b-form-radio>
                    <div
                      class="d-flex align-items-center justify-content-center"
                      :class="
                        item.status === 'Start'
                          ? 'badge'
                          : item.status === 'Stop'
                          ? 'badge-stop'
                          : item.status === 'Alarm'
                          ? 'badge-alarm'
                          : 'badge-moving'
                      "
                    >
                      {{ item.status }}
                    </div>
                  </div>
                  <hr />
                </div>
              </li>
            </ul>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import L from 'leaflet'
import {
  LMap,
  LTileLayer,
  LCircle,
  LControl,
  LControlZoom,
  LControlLayers,
  LLayerGroup,
  LPolyline,
  LMarker,
  LIcon,
  LPopup
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import LControlFullscreen from 'vue2-leaflet-fullscreen'
import LRotatedMarker from 'vue2-leaflet-rotatedmarker'
// import { latLngBounds, latLng } from 'leaflet'

import { Icon } from 'leaflet'
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BListGroup,
  BListGroupItem,
  BFormRadio,
  BBadge,
  BFormCheckbox,
  BModal,
  VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    LMap,
    LTileLayer,
    LCircle,
    LControl,
    LControlZoom,
    LControlLayers,
    LLayerGroup,
    LControlFullscreen,
    LPolyline,
    LMarker,
    LRotatedMarker,
    LIcon,
    LPopup,
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    flatPickr,
    BListGroup,
    BListGroupItem,
    BFormRadio,
    BBadge,
    BFormCheckbox,
    BModal
  },

  directives: {
    'b-modal': VBModal,
    Ripple
  },

  data() {
    return {
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // map: null,
      url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
      zoom: 15,
      center: [47.334852, -1.509485],
      centerUpdate: [],
      // centerUpdate: [-6.1492483, 106.8348383],
      markerBergerak: L.latLng(-6.21011, 106.832459),

      // map: {
      //   center: L.latLng(-6.21011, 106.832459),
      //   zoom: 12
      // },

      trackType: 'line',
      showMarker: true,

      movingSwitch: true,
      stopSwitch: true,
      alertSwitch: true,
      showElement: true,
      isAlertDisabled: false,

      dataMarkerMoving: [],
      dataMarkerAlert: [],
      dataMarkerStop: [],

      angleVehicle: '',

      data: [],
      dataDetail: [],
      polyline: {
        latlngs: [],
        color: '#1DA1F2',
        weight: 6
      },
      token: '',
      alamat: '',
      bangke: '',
      address: '',

      markers: [],
      markerx: [],
      markerStart: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: require('@/assets/images/markers/start.png'),
          iconSize: [32, 32],
          iconAnchor: [16, 16]
        }),
        visible: false
      },
      markerMoving: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: require('@/assets/images/markers/moving.png'),
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },
      markerAlert: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: require('@/assets/images/markers/alert.png'),
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },
      markerStop: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: require('@/assets/images/markers/stop.png'),
          iconSize: [32, 40],
          iconAnchor: [16, 40]
        }),
        visible: false
      },
      markerFinish: {
        position: L.latLng(0, 0),
        icon: L.icon({
          iconUrl: require('@/assets/images/markers/finish.png'),
          iconSize: [32, 32],
          iconAnchor: [18, 26]
        }),
        visible: false
      },

      tileProviders: [
        {
          name: 'Google Street',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=m@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Satellites',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Hybrid',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=s,h@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Terrain',
          visible: false,
          url: 'https://www.google.com/maps/vt?lyrs=p@189&gl=en&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'Google Traffic',
          visible: true,
          url: 'https://www.google.com/maps/vt?lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
          attribution: 'google'
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution:
            '&copy; <a target="_blank" href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        }
      ]
    }
  },

  created() {
    this.data = JSON.parse(localStorage.getItem('journeyData'))

    this.getAddress(JSON.parse(localStorage.getItem('journeyDataDetail'))).then(
      (res) => {
        this.dataDetail = res

        this.dataDetail.map((e, i) => {
          this.polyline.latlngs.push([e.lat, e.lon])
          if (e.status === 'Alarm') {
            this.dataMarkerAlert.push({
              lat: e.lat,
              lon: e.lon,
              alarm: e.alarm
            })
          }
          if (e.status === 'Moving') {
            this.dataMarkerMoving.push({
              lat: e.lat,
              lon: e.lon,
              speed: e.speed
            })
          }
          if (e.status === 'Stop') {
            this.dataMarkerStop.push({
              lat: e.lat,
              lon: e.lon
            })
          }
        })
      }
    )
  },

  computed: {
    markerVehicle() {
      return L.icon({
        iconUrl: `${this.data.fullpath_icon.acc_on}`,
        iconSize: [50, 50]
      })
    },
    markerParking() {
      return L.icon({
        iconUrl: `${this.data.fullpath_icon.parking}`,
        iconSize: [50, 50]
      })
    }

    // disableAlertButton() {
    //   return this.dataDetail.status != 'Alarm'
    // }
  },

  // watch: {
  //   disableAlertButton(val) {
  //     this.isAlertDisabled = val
  //   }
  // },

  methods: {
    latLngx(lat, lon) {
      return L.latLng(lat, lon)
    },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear(),
        hour = '' + d.getHours(),
        minute = '' + d.getMinutes(),
        second = '' + d.getSeconds()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      if (hour.length < 2) hour = '0' + hour
      if (minute.length < 2) minute = '0' + minute
      if (second.length < 2) second = '0' + second

      return (
        [year, month, day].join('-') + ' ' + [hour, minute, second].join(':')
      )
    },

    handleZoomEnd() {
      if (this.movingSwitch && this.alertSwitch) {
        this.$nextTick(() => {
          this.$refs.peta.mapObject.eachLayer((layer) => {
            if (layer instanceof L.Marker) {
              layer.setLatLng(layer.getLatLng())
            }
          })
        })
      }
    },

    convertSecToMin(second) {
      const minute = Math.floor(second / 60)
      return minute + ' Menit'
    },

    // toggleTrack() {
    //   if (this.trackType === 'line') {
    //     // toggle to dots
    //     this.trackType = 'dots'
    //   } else {
    //     // toggle to line
    //     this.trackType = 'line'
    //   }
    // }

    async getAddress(data) {
      let temp = await data.map((item, index) => {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.lat,
                longitude: item.lon
              }
            })
            .then((res) => {
              data[index].address = res.data.message
            })
        }) //index * 300
      })

      if (temp) {
        return data
      }
    },

    getAddress2(lat, lon) {
      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: lat,
            longitude: lon
          }
        })
        .then((res) => {
          return res.data.message
        })
    },

    // showAddress(item) {
    //   this.alamat = item.bangke
    // },

    showAddress(lat, lon) {
      this.address = ''

      this.$http
        .get(`${this.$api.base_url}/api/address`, {
          params: {
            latitude: lat,
            longitude: lon
          }
        })
        .then((res) => {
          this.address = res.data.message
        })
    },

    centerMap(item, icon) {
      const newZoom = 16
      this.$refs.peta.mapObject.setView(L.latLng(item.lat, item.lon), newZoom)
      // this.$refs.peta.mapObject.panTo(L.latLng(item.lat, item.lon))

      this.showElement = false
      const marker = this.$refs.vehicle.mapObject
      const newLatlng = [item.lat, item.lon]
      marker.setLatLng(newLatlng)
      this.centerUpdate = newLatlng

      this.angleVehicle = item.angle
      this.markerx = icon
        ? L.icon({
            iconUrl: `${icon.acc_on}`,
            iconSize: [50, 50]
          })
        : L.icon.Default
    }
  }
}
</script>

<style>
/* .leaflet-container .leaflet-marker-pane img {
  transition: 1000ms linear;
} */

.rotated-marker {
  transition: 1000ms linear;
}

.lokasi-awal-popup .modal-content {
  border: none;
}

.lokasi-awal-popup .lokasi-awal-header {
  background-color: #28c76f;
}

.lokasi-awal-popup h5 {
  color: #fff;
}

#lokasi-awal-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-awal-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}

.lokasi-akhir-popup .modal-content {
  border: none;
}

.lokasi-akhir-popup .lokasi-akhir-header {
  background-color: #ea5455;
}

.lokasi-akhir-popup h5 {
  color: #fff;
}

#lokasi-akhir-popup .close-modal-btn {
  position: absolute;
  top: -62px;
  right: -9px;
  background-color: #fff;
  color: #4b465c;
  font-weight: 800;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 6px;
  border: none;
}

#lokasi-akhir-popup .close-modal-btn:hover {
  background-color: #e6e6e6;
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.vue2leaflet-map {
  &.leaflet-container {
    // height: 550px;
    height: 75em;
  }
}

.parent {
  font-family: 'Poppins', sans-serif;
}
.date-input-card,
.list-card,
.map-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Date Input CSS

.date-input {
  font-weight: 600;
}

.date-input .date-picker {
  background-color: white;
  cursor: pointer;
}

.date-input .start-time,
.end-time {
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  background-color: #f8f8f8;
  opacity: 1;
  font-weight: 400;
}

.date-input #btn-cari {
  background-color: #28c76f;
  border: none;
  border-radius: 6px;
  font-weight: 500;
}

.date-input #btn-cari:hover {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Leaflet Map CSS
.timeline .session-content a,
.timeline .session-content a:hover {
  color: #1da1f2;
  text-decoration: underline;
}

.map .switch {
  margin-inline: 10px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.map .switch span {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
}

.map .switch .switch-button {
  border-radius: 25px;
}

.map .control {
  background-color: #fff;
  border-radius: 5px;
  display: flex;
  margin: 10px 0;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

[dir] .leaflet-touch .leaflet-control-layers,
[dir] .leaflet-touch .leaflet-bar {
  border: none;
  box-shadow: 0px 2px 4px rgba(91, 91, 94, 0.3);
}

[dir] .leaflet-touch .leaflet-control-layers {
  font-size: 10px;
}

// List Status CSS

.list-card {
  height: 65em;
}

.list-card .list-item-title {
  border: none;
  border-bottom: 1px solid #1da1f2;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

.list-card .list-item-title h5 {
  font-weight: 700;
  font-size: 16px;
}

.list-container {
  overflow-y: scroll;
  // height: 100px;
}

.list-item h5 {
  font-weight: 600;
  font-size: 15px;
}

.list-item p {
  font-weight: 400;
  font-size: 13px;
}

.list-item .badge {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #28c76f;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;

  &:before {
    content: url('~@/assets/images/tabler-icon/edited/flag-white.svg');
    margin-right: 5px;
  }
}

.list-item .badge-moving {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #1da1f2;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

.list-item .badge-stop {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #4b465c;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

.list-item .badge-alarm {
  width: 80px;
  height: 22px;
  padding: 0 10px;
  background-color: #db4437;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  border-radius: 5px;
}

// Timeline CSS Component
.timeline-card {
  width: 300px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
  border-radius: 8px;
}

.timeline ul,
.timeline li {
  list-style: none;
  padding: 0;
}

.timeline .timeline-sessions {
  position: relative;
}

.timeline .session-title {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-content {
  font-weight: 600;
  font-size: 1.071rem;
}

.timeline .session-date {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-date.date-parking {
  font-weight: 600;
  font-size: 0.929rem;
}

.timeline li.session-1 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #28c76f;
    box-shadow: 0px 0px 0px 4px rgba(0, 209, 232, 0.2);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-2 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #db4437;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-3 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #ff9f43;
    box-shadow: 0px 0px 0px 4px rgba(255, 159, 67, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-4 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}
</style>
